<template>
    <div id="app">
        <transition name="zoom-fade" mode="out-in">
            <router-view />
        </transition>
        <vue-confirm-dialog></vue-confirm-dialog>
    </div>
</template>

<script>
import jQuery from 'jquery'

export default {
    mounted() {
        this.handleModalStateChange()
    },

    methods: {
        handleModalStateChange() {
            window.addEventListener('popstate', () => {
                if (document.querySelector('body').classList.contains('modal-open')) {
                    jQuery('.modal').modal('hide')
                }
            })
        }
    }
}
</script>
<style lang="scss">
:root {
    --ui-primary-color: #28a745;
    --ui-secondary-color: #fff;
}
</style>
